import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    TextField,
    MenuItem,
    Checkbox,
    FormControlLabel,
    Button,
    Card,
    CardHeader,
    Divider,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    IconButton,
    Skeleton,
} from "@mui/material";
import { useFormik } from "formik";
import { AccessTime, ArrowBack, CheckCircle, Close } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import checkIcon from "../../images/checkicon.png";
import { KycService, kycStatus } from "../../asiosConfig";
import { toast } from "react-toastify";
import { kycValidationSchema } from "../ValidationSchema";
import { VerificationSuccess } from "./Kyc/VerificationSuccess";
import { VerificationPending } from "./Kyc/VerificationPending";

export const KYCVerification = () => {
    const [isOtpDialogOpen, setIsOtpDialogOpen] = useState(false);
    const [aadharRequestId, setAadharRequestId] = useState(null);
    const [adharId, setAadharId] = useState(null);
    const [aadharTaskId, setAadharTaskId] = useState(null);
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(true);
    const [otp, setOtp] = useState("");
    const navigate = useNavigate();
    // const token = localStorage.getItem("token");

    useEffect(() => {
        fetchStatus();
    }, []);
    const fetchStatus = async () => {
        try {
            const response = await kycStatus();

            if (response.status === 200 || response.status === 201) {
                setStatus(response.data.status);
            }
        } catch (error) {
            console.log("Failed to fetch KYC status.");

        } finally {
            setLoading(false);
        }

    }
    // Formik setup
    const formik = useFormik({
        initialValues: {
            selectedID: "PAN",
            idNumber: "",
            confirmation: false,
        },
        validationSchema: kycValidationSchema,
        onSubmit: async (values) => {
            if (values.selectedID === "PAN") {
                try {
                    const response = await KycService.verifyPan({ customer_pan_number: values.idNumber });
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.data.message);
                        // window.location.reload();
                        fetchStatus();
                    }
                } catch (error) {
                    toast.error(error.response?.data?.message || "PAN verification failed.");
                }
            } else {
                try {
                    const response = await KycService.requestAdharOtp({ customer_aadhaar_number: values.idNumber });

                    if (response.data.success && response.data.response_code === "100") {
                        console.log(response);
                        toast.success(response.data.response_message);
                        setAadharRequestId(response.data.request_id);
                        setAadharTaskId(response.data.task_id);
                        setIsOtpDialogOpen(true);
                       
                    } else {
                        toast.error(response.data.response_message);
                    }
                } catch (error) {
                    toast.error(error?.response?.data?.message || "Aadhar OTP request failed.");
                }
            }
        },
    });

    const handleOtpSubmit = async () => {
        try {
            const response = await KycService.verifyAdharOtp({
                request_id: aadharRequestId,
                task_id: aadharTaskId,
                customer_aadhaar_number: formik.values.idNumber,
                otp,
            });
            if (response.data.success && response.data.response_code === "100") {
                toast.success(response.data.response_message);
                setIsOtpDialogOpen(false);
                fetchStatus();
            } else {
                toast.error(response.data.response_message);
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "OTP verification failed.");
        }
    };

    return (
        <div className="col-lg-9 col-12">
            <Card className="editProfileBlock">
                <CardHeader
                    avatar={
                        <ArrowBack
                            sx={{ color: "#FF8008", cursor: "pointer" }}
                            onClick={() => navigate(-1)}
                        />
                    }
                    title="KYC Verification"
                    subheader="Complete your KYC to enhance profile authenticity and trust"
                    titleTypographyProps={{
                        sx: { color: "#FF8008", fontSize: "20px", fontWeight: "500" },
                    }}
                />
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        padding: 4,
                        backgroundColor: "#fffff",
                        // minHeight: "100vh",
                    }}
                >

                    {loading ? (
                        <>
                            <Skeleton variant="text" width="60%" height={40} sx={{ mb: 2 }} />
                            <Skeleton variant="rectangular" width="100%" height={150} sx={{ mb: 2 }} />
                            <Skeleton variant="text" width="40%" height={30} sx={{ mb: 2 }} />
                            <Skeleton variant="rectangular" width="100%" height={50} />
                        </>
                    ) : status === "verified"
                        ? (
                            <VerificationSuccess />
                        )
                        : status === "pending"
                            ? (
                                <VerificationPending />
                            ) : (
                                <Box
                                    sx={{
                                        backgroundColor: "white",
                                        padding: 4,
                                        borderRadius: 5,
                                        boxShadow: 2,
                                        width: "100%",
                                    }}
                                >
                                    <Divider variant="middle" sx={{ mb: 1, mt: 1 }} />
                                    {/* <Typography variant="h6" sx={{ mb: 3 }}> */}
                                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
                                        <Typography variant="h5" sx={{ fontWeight: 600 }}>
                                            {formik.values.selectedID === "PAN"
                                                ? "PAN Card Details"
                                                : "Aadhar Card Details"}
                                        </Typography>
                                        <TextField
                                            select
                                            value={formik.values.selectedID}
                                            onChange={(e) => {
                                                formik.setFieldValue("selectedID", e.target.value);
                                                formik.resetForm({
                                                    values: { ...formik.initialValues, selectedID: e.target.value },
                                                });
                                            }}
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                                backgroundColor: "black",
                                                color: "white",
                                                "& .MuiInputBase-input": { color: "white" },
                                                "& .MuiSvgIcon-root": { color: "white" },
                                                "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "gray" },
                                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "white",
                                                },
                                            }}
                                        >
                                            <MenuItem value="PAN">PAN Verification</MenuItem>
                                            <MenuItem value="Aadhar">Aadhar Verification</MenuItem>
                                        </TextField>
                                    </Box>
                                    <Divider variant="middle" sx={{ mb: 4 }} />
                                    <form onSubmit={formik.handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label={
                                                        formik.values.selectedID === "PAN"
                                                            ? "PAN Number"
                                                            : "Enter your 12-digit Aadhar"
                                                    }
                                                    name="idNumber"
                                                    value={formik.values.idNumber}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={
                                                        formik.touched.idNumber &&
                                                        Boolean(formik.errors.idNumber)
                                                    }
                                                    helperText={
                                                        formik.touched.idNumber && formik.errors.idNumber
                                                    }
                                                    sx={{ mb: 3 }}
                                                />
                                            </div>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name="confirmation"
                                                        checked={formik.values.confirmation}
                                                        onChange={formik.handleChange}
                                                    />
                                                }
                                                label="I hereby confirm that the details provided are true, accurate, and complete to the best of my knowledge."
                                            />
                                            {formik.touched.confirmation && formik.errors.confirmation && (
                                                <Typography variant="body2" color="error" sx={{ mt: 1, mb: 2 }}>
                                                    {formik.errors.confirmation}
                                                </Typography>
                                            )}
                                        </div>

                                        <Button
                                            type="submit"
                                            variant="contained"
                                            sx={{
                                                mt: 2,
                                                background: "linear-gradient(90deg, #FD8501 0%, #F83A01 100%)",
                                                color: "#fff",
                                                "&:hover": {
                                                    background:
                                                        "linear-gradient(90deg, #e69500 0%, #d84200 100%)",
                                                },
                                                borderRadius: 5,
                                            }}
                                        >
                                            <img src={checkIcon} width="23px" height="23px" alt="Verify" />
                                            Verify
                                        </Button>
                                    </form>
                                </Box>
                            )}
                    {/* </Typography> */}


                </Box>
            </Card>

            {/* Otp Dialog */}
            <Dialog open={isOtpDialogOpen} onClose={() => setIsOtpDialogOpen(false)}>
                <DialogTitle>Enter OTP</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Enter the OTP sent to your registered mobile number for Aadhar
                        verification.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="OTP"
                        type="text"
                        fullWidth
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsOtpDialogOpen(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleOtpSubmit} color="primary">
                        Verify OTP
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
